<template>
  <div class="home-bg">
    <van-pull-refresh v-model="isRefreshing" @refresh="onRefresh">
      <div>
        <!--最新测试结果-->
        <section class="analysis" style="margin-top: 17px;">
          <div class="title">
            <span>最新结果</span>
            <span v-if="nearData" class="time">{{ nearData.testTime }}</span>
          </div>
          <div class="bd new-height">
            <div class="bar-title">
              <div class="item color1"><span>不佳</span></div>
              <div class="item color2"><span>注意</span></div>
              <div class="item color3"><span>良好</span></div>
            </div>
            <div class="new-result">
              <van-row v-if="nearData" style="width: 100%;">
                <van-col span="8">
                  <div class="bpm" align="center">
                    <div class="num">{{ nearData.heartRate }}</div>
                    <div class="char">bpm</div>
                  </div>
                  <div class="pl-avg">平均心率</div>
                </van-col>
                <van-col span="8">
                  <div class="heart-health">
                    <img v-if="nearData.stateArr[3] === '不佳'" src="../../../assets/images/health/sixecg/circle3.png">
                    <img v-else-if="nearData.stateArr[3] === '注意'" src="../../../assets/images/health/sixecg/circle12.png">
                    <img v-else src="../../../assets/images/health/sixecg/circle.png">
                  </div>
                  <div class="pl-avg">心率健康</div>
                </van-col>
                <van-col span="8">
                  <div class="pr-per" align="center">
                    <div>
                      <img v-if="nearData.stateArr[2] === '不佳'" src="../../../assets/images/health/sixecg/rainbow-right.png">
                      <img v-else-if="nearData.stateArr[2] === '注意'" src="../../../assets/images/health/sixecg/rainbow.png">
                      <img v-else src="../../../assets/images/health/sixecg/rainbow-left.png">
                      <div class="percent">压力指数</div>
                    </div>
                    <div>
                      <img v-if="nearData.stateArr[1] === '不佳'" src="../../../assets/images/health/sixecg/rainbow-right.png">
                      <img v-else-if="nearData.stateArr[1] === '注意'" src="../../../assets/images/health/sixecg/rainbow.png">
                      <img v-else src="../../../assets/images/health/sixecg/rainbow-left.png">
                      <div class="percent">疲劳指数</div>
                    </div>
                  </div>
                </van-col>
              </van-row>
              <div v-else class="no-data">{{ $t('viewBase.a47') }}</div>
            </div>
          </div>
        </section>

        <section class="analysis">
          <div class="title">
            心率趋势(月)
          </div>
          <div id="analysis" class="bd" />
          <div v-if="!xScore.length" class="empty">{{ $t('viewBase.a47') }}</div>
        </section>

        <section class="analysis">
          <div class="title">
            健康统计(月)
          </div>
          <div class="bd">
            <div class="bar-title">
              <div class="item color1"><span>不佳</span></div>
              <div class="item color2"><span>注意</span></div>
              <div class="item color3"><span>良好</span></div>
            </div>
            <div id="barAnalysis" class="bar-echart" />
          </div>
          <div v-if="poorArr.length === 0 && careArr.length === 0 && goodArr.length === 0 " class="empty">{{ $t('viewBase.a47') }}</div>
        </section>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
import { fetchsixHb } from '@/api/health'
import { dateFormat, dateISO } from '@/utils/tool'
import { GetQueryString } from '@/utils/wechat'
import { getAccountId } from '@/utils/auth'
export default {
  props: {
    result: {
      type: Number,
      default: 1
    }
  },
  data() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    return {
      score: 0,
      scoreRatio: 0,
      xScore: [],
      yScore: [],
      isRefreshing: false,
      myChart: null,
      barChart: null,
      listQuery: {
        sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD')} 00:00:01`),
        eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD')} 23:59:59`),
        page: -1,
        row: 0
      },
      nearData: null,
      // 不佳
      poorArr: [],
      // 注意
      careArr: [],
      // 良好
      goodArr: [],
      familyList: [],
      itemArr: []
    }
  },
  created() {
    /* fetchUserInfo({}).then(res => {
      this_.info = res.data.data
    })*/
    this.getHeartData()
  },
  methods: {
    getHeartData: function() {
      var this_ = this
      /* var toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })*/
      this.listQuery.accountId = GetQueryString('accountId') || getAccountId()
      fetchsixHb(this.listQuery).then(res => {
        if (res && res.data.code === 0) {
          var data = res.data.data
          if (data && data.length !== 0) {
            this_.itemArr = ['疲劳指数', '压力指数', '心率健康']
            var healthItem = {
              poor: 0,
              care: 0,
              good: 0
            }
            var pressureItem = {
              poor: 0,
              care: 0,
              good: 0
            }
            var fatigueItem = {
              poor: 0,
              care: 0,
              good: 0
            }
            data.forEach(function(item) {
              // 折线图
              var time = dateFormat(item.testTime, 'MM-dd')
              this_.xScore.push(time)
              this_.yScore.push(item.heartRate)
              // 柱状图(state: 心率，疲劳指数，压力指数，健康指数)
              var state = item.state
              if (state) {
                var arr = state.split(',')
                // 心率健康
                if (arr[3] === '不佳') {
                  healthItem.poor += 1
                } else if (arr[3] === '注意') {
                  healthItem.care += 1
                } else if (arr[3] === '良好') {
                  healthItem.good += 1
                }
                // 压力指数
                if (arr[2] === '不佳') {
                  pressureItem.poor += 1
                } else if (arr[2] === '尚可') {
                  pressureItem.care += 1
                } else if (arr[2] === '正常') {
                  pressureItem.good += 1
                }

                // 疲劳指数
                if (arr[1] === '过劳') {
                  fatigueItem.poor += 1
                } else if (arr[1] === '轻松') {
                  fatigueItem.care += 1
                } else if (arr[1] === '正常') {
                  fatigueItem.good += 1
                }
                console.log(arr[1], '1')
              }
            })
            this_.poorArr[0] = fatigueItem.poor
            this_.poorArr[1] = pressureItem.poor
            this_.poorArr[2] = healthItem.poor

            this_.careArr[0] = fatigueItem.care
            this_.careArr[1] = pressureItem.care
            this_.careArr[2] = healthItem.care

            this_.goodArr[0] = fatigueItem.good
            this_.goodArr[1] = pressureItem.good
            this_.goodArr[2] = healthItem.good
            // this_.xScore.reverse()
            // this_.yScore.reverse()
            // 最近测量值
            var nd = data[0]
            // 时间处理
            nd.testTime = dateFormat(data[0].testTime, 'yyyy-MM-dd')
            // 状态处理
            var state = nd.state
            if (state) {
              nd.stateArr = state.split(',')
            }
            this_.nearData = nd
          }
          // 初始化图表
          this_.charts()
          this_.barCharts()
        }
      })
    },
    barCharts() {
      this.barChart = echarts.init(document.getElementById('barAnalysis'))
      // 绘制图表
      this.barChart.setOption({
        tooltip: {},
        grid: {
          left: '3%', // 图表距边框的距离
          right: '6%',
          top: '10%',
          bottom: '3%',
          containLabel: true
        },
        /* dataset: {
          source: [
            ['疲劳指数', 83.1, 73.4, 55.1],
            ['压力指数', 86.4, 65.2, 82.5],
            ['心率健康', 72.4, 53.9, 39.1]
          ]
        },*/
        xAxis: {},
        yAxis: {
          type: 'category',
          data: this.itemArr
        },
        series: [
          {
            name: '不佳',
            type: 'bar',
            data: this.poorArr,
            barWidth: 7,
            barGap: '0%',
            itemStyle: {
              color: '#FF0000'
            }

          },
          {
            name: '注意',
            type: 'bar',
            data: this.careArr,
            barGap: '0%',
            barWidth: 7,
            itemStyle: {
              color: '#FFB400'
            }
          },
          {
            name: '良好',
            type: 'bar',
            data: this.goodArr,
            barWidth: 7,
            barGap: '0%',
            itemStyle: {
              color: '#00D2FF'
            }
          }
        ]
      })
    },
    charts() {
      this.myChart = echarts.init(document.getElementById('analysis'))
      // 绘制图表
      this.myChart.setOption({
        grid: {
          left: '4%', // 图表距边框的距离
          right: '4%',
          top: '13%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.xScore,
          axisLine: {
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#333'
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#333'
          }
        },
        series: [{
          data: this.yScore,
          type: 'line',
          lineStyle: {
            color: '#F18937'
          },
          itemStyle: {
            color: 'yellowgreen'
          }
        }]
      })
    },
    onRefresh() {
      setTimeout(() => {
        // this.$toast('刷新成功')
        this.isRefreshing = false
        this.getFamilyList()
        this.myChart.dispose()
        this.barChart.dispose()
        this.charts()
        this.barCharts()
      }, 500)
    },
    toItem(item) {
      this.$router.push(`/health/${item}`)
    }

  }
}
</script>

<style scoped lang="scss">
  .no-data{
    text-align: center;
    color: #999;
    font-size: 0.24rem;
    width: 100%;
    position: absolute;
    top: 50%;
    padding-right: 28px;
  }
  .pl-avg{
    padding-left: 5px;
  }
  .new-height{
    height: 140px!important;
  }
  .sugar-chart{
    height: 170px;
  }
  .new-data-img{
    width: 100%;
    height: 4.6rem;
  }
  .home-bg{
    min-height: calc(100vh - 1rem);
    background: white;
  }
  .userInfo{
    height: 74px;
    margin-top: 0.92rem;
    padding-left: 14px;
    background:rgba(242,242,242,1);
    .item-div{
      height: 74px;
      display: flex;
      align-items: center;
      .name{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(23,23,23,1);
        line-height:11px;
        margin-left: 11px;
      }
      .sex{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(241,137,55,1);
        line-height:11px;
        margin-left: 9px;
      }
    }
  }
  .user-img{
    width: 54px;
    height: 54px;
    border-radius: 100px;
  }
  .user-div{
    float: left;
    width: 33.33%
  }
  .user-name{
    font-size: 16px;
    vertical-align: middle;
    text-align: center;
    line-height: 84px;
  }
  .user-name-left{
    margin-left: -10px;
  }
  .icon-arrow{
    float: right;
    right: -12px;
  }
  .home-hd {
    padding: 40px 15px 0;
    margin-bottom: 15px;
    background-image: linear-gradient(to bottom, #FFCA30 0,#F9F8F8 20% )
  }
  .analysis,.sport {
    .iconfont {
      font-size: 20px;
      color: #999;
      vertical-align: -2px;
      margin-right: 5px;
    }
    .title {
      font-size: 18px;
      color: #171717;
      font-family:PingFangSC-Medium;
      font-weight:500;
      margin-left: 6px;
      line-height:22px;
      padding-bottom: 10px;
      .time{
        float: right;
        right: 13px;
        font-size:15px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(125,125,125,1);
        line-height:26px;
      }
    }
  }
  .analysis {
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
    padding-left: 12px;
    padding-right: 12px;
    .bd {
      height: 180px;
      background: #fff;
      border-radius: 10px;
      box-shadow:0px 0px 24px 0px rgba(0, 0, 0, 0.1);
     /* -webkit-box-shadow: #666 0px 0px 10px;
      -moz-box-shadow: #666 0px 0px 10px;
      box-shadow: #666 0px 0px 10px;*/
    }
    .bar-title{
      height: 20px;
      float: right;
      padding-right: 19px;
      padding-top: 7px;
      .item{
        float: left;
        margin-left: 15px;
        line-height:15px;
        span{
          padding-left: 5px;
          font-size: 10px;
          font-family: PingFang SC;
          color: rgba(125,125,125,1);
        }
      }
      .color1{
        border-left: solid 3px #FF0000;
      }
      .color2{
        border-left: solid 3px #FFB400;
      }
      .color3{
        border-left: solid 3px #00D2FF;
      }
    }
    .bar-echart{
      height: 160px;
    }
    .new-result{
      width: 100%;
      height: 123px;
      display: flex;
      align-items: center;
      margin-left: 14px;
      .pr-per{
        padding-right: 14px;
        img{
          width: 83px;
          height: 9px;
        }
        .percent{
          font-size:13px;
          font-family:PingFang SC;
          font-weight:400;
          color:rgba(125,125,125,1);
        }
      }
      .heart-health{
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-size: contain;
        img{
          width: 68px;
          height: 68px;
        }
      }
      .bpm{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 68px;
        height: 68px;
        background-image: url(../../../assets/images/health/sixecg/bpm.png);
        background: url(../../../assets/images/health/sixecg/bpm.png) 100% 100%;
        background-size: contain;
        .num{
          font-size:27px;
          font-family:PingFang SC;
          font-weight:600;
          color:rgba(0,0,0,1);
          line-height:21px;
        }
        .char{
          font-size:11px;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(0,0,0,1);
        }
      }
    }
    .empty {
      text-align: center;
      color: #999;
      font-size: 12px;
      width: 100%;
      position: absolute;
      top: 50%;
    }
  }
  /*。../../../assets/images/health/sixecg/new-data-bg.png*/
  .new-data-result{
    width: 369px;
    height:191px;
    margin: 9px auto 0;
    background: url('../../../assets/images/health/sixecg/new-data-bg.png') no-repeat;
    background-size: 100% 100%;
    padding:12px 11px;
    .left{
      height:18px;
      font-size:18px;
      font-family:PingFangSC-Regular;
      font-weight:200;
      color:rgba(255,255,255,1);
      line-height:36px;
      text-indent: 14px;
      display: inline-block;
    }
    .right{
      width:115px;
      height:34px;
      background:rgba(252,189,139,1);
      opacity:0.7;
      font-size:14px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:34px;
      float: right;
      margin-top: 10px;
      text-align: right;
      border-radius: 60px 0 0 60px;
      img{
        width: 17px;
        height: 17px;
        margin-right: 4px;
      }
    }
    .near-one-data{
      text-align: center;
      padding-top: 31px;
      span{
        color: white;
      }
      .nume{
        font-family:PingFangSC-Medium;
        font-size:68px;
        font-weight: 500;
        line-height: 50px;
        display: inline-block;
        height: 50px;
      }
      .unit{
        font-family:PingFangSC-Regular;
        font-size:16px;
      }
    }
  }
  .van-nav-bar .van-icon {
    vertical-align: middle;
    margin-top: -3px;
  }
  /deep/.van-swipe__indicator {
    background-color: #CFCFCF;
  }
  /deep/.van-swipe__indicator--active {
    background-color: #F18937;
    opacity: 1;
  }
</style>
